let revokeRedirectFlowInProgress = false;

export const startRevokeRedirectFlow = (): void => {
  revokeRedirectFlowInProgress = true;
};

export const stopRevokeRedirectFlow = (): void => {
  revokeRedirectFlowInProgress = false;
};

export const isRevokeRedirectFlowInProgress = (): boolean => revokeRedirectFlowInProgress;
